export enum RejectOrderStatusEnum {
    no_access_to_gas_equipment = 'Нет доступа к газовому оборудованию',
    only_minors_in_the_apartment = 'В квартире только несовершеннолетние',
    not_the_owner = 'Не собственник',
    faulty_gas_equipment = 'Неисправное газовое оборудование',
    refusal_of_service_by_phone = 'Отказ от обслуживания по телефону',
    no_access_to_the_apartment = 'Отсутствует доступ в квартиру',
    inaccurate_or_wrong_address = 'Неточный или неверный адрес',
    high_workload = 'Высокая загруженность',
    other = 'Иная',
}

